import { useEffect } from "react"

function ImgRandomEventi({ onDataSubmit }) {
    useEffect(() => {
        const fotoDaScegliere = [

            { tipologia: 'Enogastronomico', foto: ['Enogastronomia1.webp', 'Enogastronomia2.webp', 'Enogastronomia3.jpg', 'Enogastronomia4.webp', 'Enogastronomia5.webp'] },
            { tipologia: 'Halloween', foto: ['halloween1.jpg', 'halloween2.webp', 'halloween3.jpg'] },
            { tipologia: 'Mercatino natalizio', foto: ['mercatinoNatale1.jpg', 'mercatinoNatale2.jpg', 'mercatinoNatale3.webp', 'mercatinoNatale4.jpg', 'mercatinoNatale5.webp', 'mercatinoNatale6.webp'] },
            { tipologia: 'Natale', foto: ['natale1.webp', 'natale2.webp', 'natale3.webp', 'natale4.webp', 'natale5.webp', 'natale6.webp'] },
            { tipologia: 'Presepe', foto: ['presepe1.webp', 'presepe2.webp', 'presepe3.webp', 'presepe4.webp', 'presepe5.webp'] },
            { tipologia: 'Fiera', foto: ['fiera1.webp', 'fiera2.webp'] },
        ]
        onDataSubmit(fotoDaScegliere)
    }, [])
}
export default ImgRandomEventi